interface Set {
    [key: string]: boolean;
}

function toSet<T extends { toString(): string }>(
    items: Array<T>,
    toString: (item: T) => string = (item: T) => item.toString()
) {
    const itemsSet: Set = {};
    items.forEach((item) => {
        itemsSet[toString(item)] = true;
    });
    return itemsSet;
}

export { type Set, toSet };
